'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var component$y = require('./component-ad6581c1.js');
var component_styles$3 = require('./component.styles-cd2da23e.js');

var HqoTimePicker = function (params) { return (React__default.createElement(component$y.HqoPicker, tslib_es6.__assign({}, params, { fieldIcon: React__default.createElement(component_styles$3.AccessTimeStyled, { variant: "adminGreyDark", "data-testid": "hqo-time-picker-icon", className: "time-picker-icon" }) }))); };

exports.HqoTimePicker = HqoTimePicker;
